<template>
    <div class="anjian">
        <div v-wechat-title="$route.meta.title"></div>
        <Card class='card-left'>
            <Menu mode="vertical" theme="light" :active-name="menuName" :open-names="openNames" @on-select='menuItem'>
                <div v-for="(item,index) in userInfo.menuList.finance.children" :name="item.key" :key="index">
                    <MenuItem v-if="item.children.length == 0" :name="item.key" :key="index">
                        <span style="font-weight: bold;">{{item.name}}</span>
                    </MenuItem>
                    <Submenu v-else :name="item.key">
                        <template slot="title">
                            <img :src="iconList[index]" class="menuIcon"/>
                            <span style="font-weight: bold;">{{item.name}}</span>
                        </template>
                        <div v-for="(value,key) in item.children">
                            <MenuItem
                                    v-if="(value.key == 'medium_count' && userInfo.menuList.finance.medium_manage_check_medium_count)"
                                    :name="value.key" :key="key">{{value.name}}</MenuItem>
                            <MenuItem
                                    v-else-if="(value.key == 'medium_withdraw' && userInfo.menuList.finance.medium_manage_check_medium_withdraw)"
                                    :name="value.key" :key="key">{{value.name}}</MenuItem>
                            <MenuItem
                                    v-else-if="(value.key == 'other_management' && userInfo.menuList.finance.expenditure_manage_check_other_management)"
                                    :name="value.key" :key="key">{{value.name}}</MenuItem>
                            <MenuItem
                                    v-else-if="(value.key == 'other_audit' && userInfo.menuList.finance.expenditure_manage_check_other_audit)"
                                    :name="value.key" :key="key">{{value.name}}</MenuItem>
                            <MenuItem
                                    v-else-if="(value.key == 'cost_report' && userInfo.menuList.finance.expenditure_manage_check_cost_report)"
                                    :name="value.key" :key="key">{{value.name}}</MenuItem>
                            <MenuItem
                                    v-else-if="(value.key == 'recharge_detail' && userInfo.menuList.finance.expenditure_manage_check_recharge_detail)"
                                    :name="value.key" :key="key">{{value.name}}</MenuItem>
                            <MenuItem
                                    v-else-if="(value.key == 'consumption_report' && userInfo.menuList.finance.expenditure_manage_check_consumption_report)"
                                    :name="value.key" :key="key">{{value.name}}</MenuItem>
                            <MenuItem
                                    v-else-if="(value.key != 'medium_withdraw' && value.key != 'medium_count' && value.key != 'other_management' && value.key != 'other_audit' && value.key != 'cost_report' && value.key != 'recharge_detail' && value.key != 'consumption_report')"
                                    :name="value.key" :key="key">{{value.name}}</MenuItem>
                        </div>
                    </Submenu>
                </div>
            </Menu>
        </Card>
        <div class='card-right-top'>
            <GatheringAffirm v-if="menuName == 'gathering_affirm' "></GatheringAffirm>
            <RefundAdmin v-if="menuName == 'refund_admin' "></RefundAdmin>
            <SincerityDetail v-if="menuName == 'sincerity_detail' "></SincerityDetail>
            <ContractExamine v-if="menuName == 'contract_examine' "></ContractExamine>
            <ReturnedAdmin v-if="menuName == 'returned_admin' "></ReturnedAdmin>
            <CostReport v-if="menuName == 'cost_report' "></CostReport>
            <RechargeDetail v-if="menuName == 'recharge_detail' "></RechargeDetail>
            <Generate v-if="menuName == 'generate' "></Generate>
            <History v-if="menuName == 'history' "></History>
            <MediumCount v-if="menuName == 'medium_count' "></MediumCount>
            <MediumWithdraw v-if="menuName == 'medium_withdraw' "></MediumWithdraw>
            <consumptionReport v-if="menuName == 'consumption_report' "></consumptionReport>
            <otherManagement v-if="menuName == 'other_management' "></otherManagement>
            <otherAudit v-if="menuName == 'other_audit' "></otherAudit>
            <earningsStatement v-if="menuName == 'earnings_statement' "></earningsStatement>
        </div>
    </div>
</template>

<script>
    import ContractExamine from './ContractExamine.vue'
    import GatheringAffirm from './GatheringAffirm.vue'
    import RefundAdmin from './RefundAdmin.vue'
    import SincerityDetail from './SincerityDetail.vue'
    import ReturnedAdmin from './ReturnedAdmin.vue'
    import CostReport from './CostReport.vue'
    import RechargeDetail from './RechargeDetail.vue'
    import Generate from './Generate.vue'
    import History from './History.vue'
    import MediumCount from './MediumCount.vue'
    import MediumWithdraw from './MediumWithdraw.vue'
    import consumptionReport from './consumptionReport.vue'
    import otherManagement from './otherManagement.vue'
    import otherAudit from './otherAudit.vue'
    import earningsStatement from './earningsStatement.vue'
    import {mapGetters} from "vuex";

    export default {
        name: "Finance",
        components: {
            ContractExamine,
            GatheringAffirm,
            RefundAdmin,
            SincerityDetail,
            ReturnedAdmin,
            CostReport,
            RechargeDetail,
            Generate,
            History,
            MediumCount,
            MediumWithdraw,
            consumptionReport,
            otherManagement,
            otherAudit,
            earningsStatement
        },
        computed: {
            ...mapGetters(['userInfo'])
        },
        created() {
            // 初始化菜单图标
            this.initIcon();
        },
        mounted() {
            let that = this;
            this.userInfo.menuList.finance.children[0].children.forEach(function (row, index) {
                if (row.key == 'medium_count' && that.userInfo.menuList.finance.medium_manage_check_medium_count) {
                    that.menuName = row.key;
                    return ;
                } else if (row.key == 'medium_withdraw' && that.userInfo.menuList.finance.medium_manage_check_medium_withdraw) {
                    that.menuName = row.key;
                    return ;
                } else if (row.key == 'other_management' && that.userInfo.menuList.finance.expenditure_manage_check_other_management) {
                    that.menuName = row.key;
                    return ;
                } else if (row.key == 'other_audit' && that.userInfo.menuList.finance.expenditure_manage_check_other_audit) {
                    that.menuName = row.key;
                    return ;
                } else {
                    that.menuName = row.key;
                    return ;
                }
            })
        },
        data() {
            return {
                menuName: '',
                openNames: [],
                iconList: [],
            }
        },
        methods: {
            initIcon() {
                let that = this
                this.userInfo.menuList.finance.children.forEach(function (row, index) {
                    that.iconList[index] = require('../../assets/icons/finance/'+row.key+'.png');
                })
            },
            menuItem(e) {
                this.menuName = e;
            },
        }

    }
</script>

<style scoped lang="less">

    .menuIcon{
        display: inline-block;
        width: 15px;
        height: 15px;
        vertical-align: middle;
        margin-bottom: 3px;
        margin-right: 5px;
    }
</style>